import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../input/FormInput';

function Mirror({ name, reference, ...props }) {
    const {
        watch,
        setValue,
        clearErrors,
        trigger,
        getValues,
        // wrap
    } = useFormContext();
    const { referenceField, referenceMap } = reference;

    useEffect(() => {
        const value = getValues(referenceField);

        const result = !!referenceMap ? referenceMap[value] : value;
        // calling setValue does not call onChange
        // validation methods need to manually be called
        clearErrors([name]);
        setValue(name, result);
        trigger([name]);
    }, [watch(referenceField)]);

    return <FormInput name={name} {...props} />;
}

export default Mirror;
